import { IGatsbyImageData } from 'gatsby-plugin-image';

const getImageSrcFromGatsbyImageData = (gatsbyImageData: IGatsbyImageData) => {
	
  if (gatsbyImageData.images.fallback?.src) {
    return gatsbyImageData.images.fallback?.src;
  } else if (gatsbyImageData.images?.sources?.[0].srcSet) {
    return gatsbyImageData.images?.sources?.[0].srcSet.substring(
      0,
      gatsbyImageData.images?.sources?.[0].srcSet.indexOf(' ')
    );
  } else {
    return '';
  }
};

export default getImageSrcFromGatsbyImageData;
